import React, { useEffect, useState } from 'react';
import './notification.style.scss';
import { __NotificationProps } from './notification.interface';
import { NotificationType, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import NotificationCard from './notificationCard/notificationCard.index';
import NotificationSkeletonCard from './notificationCard/notificationCard.skeleton';
import { useHistory } from 'react-router-dom';
import { get } from 'scripts/api';
import { API } from 'data';
import { Pagination } from 'interface';

const Notification: React.FC<ConnectedProps<typeof connector> & __NotificationProps> = (
    props: ConnectedProps<typeof connector> & __NotificationProps,
) => {
    const history = useHistory<any>();
    const [list, setList] = useState<NotificationType[]>();
    const lang = props.lang.notification;

    useEffect(() => {
        get<Pagination<NotificationType>>(API.notification.notifications(), { page: 1, page_size: 1000 }).then(
            (res) => {
                if (res.data?.data) {
                    setList(res.data.data);
                } else setList([]);
            },
        );
    }, []);

    return (
        <div className={`ucheck-kiosk-notification`}>
            <div className="notification-header">
                <i onClick={() => history.goBack()} className="material-icons">
                    east
                    <span>{lang.notification}</span>
                </i>
                <span />
                {/* <i onClick={() => setIsSearchActive(true)} className="material-icons-outlined">
                    search
                </i> */}
                {/* <i className="material-icons-outlined">notifications</i> */}
            </div>
            <div className="notification-card-list">
                {list ? (
                    list.length ? (
                        <div className="card-list mt-4">
                            {list.map((item) => (
                                <NotificationCard
                                    key={item.id}
                                    text={item.body}
                                    icon="update"
                                    time={item.created_at}
                                    isNew={false}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="empty-state">
                            <i className="material-icons-outlined">notifications</i>
                            <span>{lang.emptyState}</span>
                        </div>
                    )
                ) : (
                    <div className="skeleton-box">
                        <NotificationSkeletonCard />
                        <NotificationSkeletonCard />
                        <NotificationSkeletonCard />
                        <NotificationSkeletonCard />
                        <NotificationSkeletonCard />
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(Notification);
